import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ContractorAgreement } from '../../interfaces/configuration/contractor-agreement';

@Injectable()

export class ContractorAgreementService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<ContractorAgreement[] | boolean> {
    return new Observable<ContractorAgreement[] | boolean>((o: Subscriber<ContractorAgreement[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.contractor-agreement.index')).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ContractorAgreement[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number, user_id?: number): Observable<ContractorAgreement | boolean> {
    return new Observable<ContractorAgreement | boolean>((o: Subscriber<ContractorAgreement | boolean>) => {
      const subscription: Subscription = this.api.get((user_id
            ? this.apiEndpoints.get('configuration.contractor-agreement.read-for-user', {':id': id, ':user_id': user_id})
            : this.apiEndpoints.get('configuration.contractor-agreement.read', {':id': id})
        )
      ).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ContractorAgreement>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  create(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('configuration.contractor-agreement.create'), formData);
  }
}
